import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

// import { createStore, applyMiddleware, compose } from "redux"; /* Version dev */
import { createStore } from "redux"; /* Version prod */

import App from "./components/app";
import reducers from "./reducers";

import "bootstrap3/dist/css/bootstrap.css";
import "./css/styles.css";

// const composeEnhancers =
//     window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; /* Version dev */
// const store = createStore(
//     reducers,
//     composeEnhancers(applyMiddleware())
// ); /* Version dev */

const store = createStore(reducers); /* Version rpod */

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.querySelector("#app")
);
